<div class="d-flex align-items-center w-100 flex-column spacing-16 justify-content-center">
  <img class="w-100" height="231" width="505" ngSrc="/assets/error.svg" priority />
  <div class="d-flex flex-column spacing-16 align-items-center text-center">
    <h2 class="h2-subheaders alert-140">{{ errorMessage?.title }}</h2>
    <span class="h3-reg alert-160">{{ errorMessage?.message }}</span>
  </div>
</div>
